import { memo } from 'react';
import { FavoriteSearch } from '@app/common';

const FavoritesPage = memo(() => {
  return <FavoriteSearch />;
});

export default FavoritesPage;
